/**
 * @namespace Stores
 * @category Stores
 * @module latest-passed-vehicles
 * */

const createState = () => ({
  addressResult: {
    lat: null,
    lng: null,
    formatted: '',
  },
})

export default {
  namespaced: true,
  state: createState(),
  getters: {
    addressResult: (state) => state.addressResult,
  },
  mutations: {
    reset(state) {
      Object.assign(state, createState())
    },
    setAddress(state, addressResult = {}) {
      state.addressResult = addressResult
    },
  },
  actions: {
    reset({ commit }) {
      commit('reset')
    },
    setAddress({ commit }, addressResult) {
      commit('setAddress', addressResult)
    },
  },
}
